export const APP_CONSTANT = {
    USER_INFO: 'user_data',
    USER_ACCESS_TOKEN: 'access_token'
}

export const WHATSAPP_NUMBER = "919820828804";
export const WHATSAPP_PREFILLED_MSG = "Hi, I would like to know more about ";